/* eslint-disable class-methods-use-this */
import Vue from 'vue';
import GstplnApp, { GstplnAppCategory } from '../app';

export default class YeatApp extends GstplnApp {
  constructor(vue: Vue) {
    super(vue, 'app.yeat', {
      categories: [GstplnAppCategory.BookingPartners],
      hasDarkIcon: true,
      configComponentImportFnc: () => import('@/components/apps/yeat/SettingsDialog.vue'),
    });
  }
}
